import React from 'react';
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { db, user } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDocs, where } from 'firebase/firestore';
import Javascript from './Javascript';
import ReactJs from './ReactJs';
import Angular from './Angular';
import Flutter from './Flutter';
import Ionic from './Ionic';
import PortfolioHeader from '../Header';

const Frontend = () => {
    const [link, setLink] = useState('javascript');
    const [portfolioData, setPortfolioData] = useState([]);

    /* function to get all tasks from firestore in realtime */
    useEffect(() => { 
        console.log(link); 
        if(user) {
            fetchPortfolioData();
        }
    }, [link]);

    const fetchPortfolioData = async () => {
        const q = query(collection(db, 'portfolio'), where('project_type',"array-contains", 'webapp'));
        const querySnapshot = await getDocs(q);
        setPortfolioData(querySnapshot.docs.map(doc => ({
            id: doc.id,
            data: doc.data()    
        })));
    }
    useEffect(() => {
        console.log(portfolioData);
    }, [portfolioData]);
    return (
        <>
            <PortfolioHeader />
            <div className="gearsBg">
                <div className="wheel8"></div>
                <div className="wheel9"></div>
                <div className="wheel10"></div>
                <ul className="innerTopNav">
                    <li><Link to="/portfolio/frontend"  className="active"><span>Front-end Stack</span></Link></li>
                    <li><Link to="/portfolio/uiux"><span>UI/UX</span></Link></li>
                    <li><Link to="/portfolio/middleware" ><span>Middleware</span></Link></li>
                    <li><Link to="/portfolio/digitalmarketing" ><span>Digital Marketing</span></Link></li>
                </ul>
            </div>
            <div className="paper">
                <div className="top">&nbsp;</div>
                <div className="mid clearfix">
                    <div className="leftnav"> 
                        <ul id="leftnav">
                            <li><span onClick={() => { setLink('javascript') }} className={link === 'javascript' ? 'active' : ''}>JavaScript</span></li>
                            <li><span onClick={() => { setLink('react') }} className={link === 'react' ? 'active' : ''}> ReactJS</span></li>
                            <li><span onClick={() => { setLink('angular') }} className={link === 'angular' ? 'active' : ''}>Angular</span></li>
                            {/* <li><span onClick={() => { setLink('flutter') }} className={link === 'flutter' ? 'active' : ''}>Flutter</span></li> */}
                            <li><span onClick={() => { setLink('ionic') }} className={link === 'ionic' ? 'active' : ''}>Ionic</span></li>
                        </ul>
                    </div>
                    <div className="maincontent">
                       {/*  <div className="breadcrumb">
                            <a href="index.php">Home</a> » Visual Design
                        </div> */}
                        {(() => {
                            switch (link) {
                                case 'javascript':
                                    return <Javascript />
                                case 'react':
                                    return <ReactJs portfolioData={portfolioData} />
                                case 'flutter':
                                    return <Flutter />
                                case 'ionic':
                                    return <Ionic />
                                case 'angular':
                                    return <Angular  portfolioData={portfolioData} />
                                default:
                                    return null
                            }
                        })()}
                        {/* <div>
                            <img src="/images/skin1/website-portfolio-banner.jpg" />
                        </div> */}
                        {/* {
                            link==='javascript' && 
                            <Javascript >
    
                            </Javascript>
                        }
                         {
                            link==='react' && 
                            <ReactJs> 
                            </ReactJs>
                        } */}
                        {/* <h1>Recent Projects</h1>
                        <div className="testimony clearfix">
                            <div className="proj-tn">
                                <a className="proj-tnimg" href="projdetails.php?proj_code=20&amp;portfolio_id=1&amp;proj_type_id=1&amp;project_type=Website Design">
                                    <img src="/images/webportfolio/aa_pilot.jpg" /></a>
                            </div>
                            <div className="testimony">
                                <h2>Alaska Airlines Mobile</h2>
                                <p>"Please take a moment and congratulate the BAC Alaska Airlines Project Team for a successful go live!! Eight weeks ago this team came together and executed against a very aggressive plan to deploy the first BAC-US mobile-optimized credit card app hosted by AT&amp;T. They also sacrificed weekends and deferred vacations to ensure we hit our deliverable dates. Today, we obtained production certification sign-off with no issues. " <br /> - Project manager</p>
                            </div><br className="clear" />
                            <div className="proj-tn">
                                <a className="proj-tnimg" href="projdetails.php?proj_code=1&amp;portfolio_id=1&amp;proj_type_id=1&amp;project_type=Website Design">
                                    <img src="/images/webportfolio/plygem_pilot.jpg" /></a>
                            </div>
                            <div className="testimony">
                                <h2>PlyGem</h2>
                                <p>"It's thanks to the hard work and dedication of this team that the client is very happy with their new portals and we have been in talks for upcoming additional projects for additional portals leading into 2013 and hopefully beyond." <br /> - Project manager</p>
                            </div><br className="clear" />
                            <div className="proj-tn">
                                <a className="proj-tnimg" href="projdetails.php?proj_code=2&amp;portfolio_id=1&amp;proj_type_id=1&amp;project_type=Website Design"><img src="/images/webportfolio/ecampus_pilot.jpg" /></a>
                            </div>
                            <div className="testimony-desc">
                                <h2>eCampusTours.com</h2>
                                <p>"I wanted to thank both Dinesh and Ramarao for all the work they have done on this project, they really delivered something that looks amazing."  - Project manager</p>
                            </div><br className="clear" />
                            <p className="right-float"><strong>View our complete <a href="portfoliosubcategory.php?portfolio_id=1&amp;proj_type_id=1&amp;project_type=Website Design">Website design portfolio »</a></strong></p><strong>
                            </strong></div><strong>
                        </strong></div>
                    <div className="btm">&nbsp;</div> */}
                    </div>
                </div>
            </div>
        </>
    )

}
export default Frontend;